module.exports = __webpack_public_path__ + "static/media/200009_clusters.f4305a8e.jpg";